import React from 'react';
import { MdCircle } from 'react-icons/md';
import tailwindTheme from '../../../../config/tailwind.config';

/**
 * Constants for notes
 * status converter for dropdown
 */
export const numberValueForStatus = {
  closed: 0,
  open: 1,
  review: 2,
};
/**
 * priority options for the dropdown
 */
export const priorityOptions = [
  { value: 'no_priority', label: 'No priority', icon: <MdCircle color={tailwindTheme.theme.extend.colors['vamos-gray']} /> },
  { value: 'low', label: 'Low', icon: <MdCircle color={tailwindTheme.theme.extend.colors['priority-low']} /> },
  { value: 'medium', label: 'Medium', icon: <MdCircle color={tailwindTheme.theme.extend.colors['priority-medium']} /> },
  { value: 'high', label: 'High', icon: <MdCircle color={tailwindTheme.theme.extend.colors['priority-high']} /> },
];
/**
 * lookup map for priority value
 * easy to look up label and icon from a priority string
 */
export const priorityMap = Object.fromEntries(
  priorityOptions.map(({ value, label, icon }) => [value, { label, icon }]),
);

/**
 * status options for the dropdown
 */
export const statusOptions = [
  { value: 'open', label: 'Open' },
  { value: 'closed', label: 'Closed' },
  { value: 'review', label: 'Review' },
];

/**
 * function to handle long title in the toast message
 * @param {string} title
 * @returns
 */

export const handleLongTitle = (title) => {
  if (title.split(' ').length <= 3) return title;
  return title.split(' ').slice(0, 3).join(' ').concat('', '...');
};

/**
 * function to replace underscore with space
 * @param {string} string
 */

export const replaceUnderscoreToSpace = (string) => {
  if (!string?.includes('_')) return string;
  return string.replace(/_/g, ' ');
};

/**
 * top border color for view note modal
 * @param {string} note
 * @returns
 */

export const borderColor = (note) => {
  if (note.priority === 'low') return 'border-priority-low';
  if (note.priority === 'medium') return 'border-priority-medium';
  if (note.priority === 'high') return 'border-priority-high';
  return 'border-vamos-gray';
};

/**
 * function to handle error message if required fields are empty
 * @param {obj} data
 * @returns
 */

export const handleErrorMessage = (data) => {
  // checking if required fields are filled
  const errors = {};
  if (data.date === '') {
    errors.date = 'Date is required.';
  }
  if (data.title === '') {
    errors.title = 'A title is required.';
  }
  return errors;
};

/**
 *function to format the note data for create/update note
 * @param {obj} data
 * @param {boolean} isAddMode
 * @param {number} siteId
 * @param {number} currentUserId
 * @returns
 */

export const formatNoteData = (data, isAddMode, siteId, currentUserId) => {
  const formattedData = { ...data };
  if (typeof data.status === 'string') {
    formattedData.status = numberValueForStatus[data.status];
  }
  // need to modify data for create note
  if (isAddMode) {
    formattedData.site_id = siteId;
    formattedData.user_id = currentUserId;
  }
  return formattedData;
};
